export const testAttributes = {
    HEADER_MENU: 'header_menu',
}

export const GLOBAL_NAV_KEY = 'qlGlobalNav';
export const GLOBAL_NAV_PARAM = 'globalNav';
export const GLOBAL_NAV_CONTENT = 'GLOBAL NAVIGATION CONTAINER';